export class Constants {
    static KEY_DEFAULT_LANGUAGE = 'evSpot_dl';
    static KEY_DARK_MODE = 'evSpot_dark_mode';
    static KEY_IS_DEMO_MODE = 'evSpot_is_demo_mode';

    static THEME_MODE_DARK = "theme_dark";
    static THEME_MODE_LIGHT = "theme_light";

}